/**
 * Represent-style mobile header scroll behaviour.
 *
 * Hides the header when scrolling DOWN past a threshold, shows it
 * instantly when scrolling UP. Mobile only (≤ 768 px). Desktop
 * keeps the existing sticky-always-visible behaviour untouched.
 *
 * The CSS that actually performs the translate is in theme.css /
 * layout/theme.liquid alongside the include of this script.
 */
(function () {
  if (window.__headerScrollHideInit) return;
  window.__headerScrollHideInit = true;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  if (!isMobile()) {
    // Install lazily if the viewport crosses the mobile breakpoint
    // later (device rotation, devtools toggle).
    window.addEventListener('resize', function once() {
      if (isMobile()) {
        window.removeEventListener('resize', once);
        install();
      }
    });
    return;
  }

  install();

  function install() {
    var root = document.documentElement;
    var lastY = window.scrollY || 0;
    // Users get a grace period at the top of the page before the
    // hide behaviour engages — they haven't really "started browsing" yet.
    var threshold = 80;
    // Accumulate small scrolls before committing to a direction change
    // so a few stray sub-pixel deltas from momentum don't cause flicker.
    // But ANY upward scroll beyond a single frame still reveals the
    // header — users scrolling up expect to see nav.
    var upAccum = 0;
    var downAccum = 0;
    var commitPx = 6;  // px of accumulated scroll before we flip state
    var ticking = false;

    function update() {
      var y = Math.max(0, window.scrollY || 0);
      var dy = y - lastY;
      lastY = y;
      ticking = false;

      // A modal / drawer is open — the user's not navigating, do nothing.
      if (document.body.style.overflow === 'hidden') return;

      // Toggle a single "is-scrolled" flag. The mobile-sticky CSS uses
      // this on the homepage to swap the header background from
      // transparent (overlaying the hero) to opaque (once the hero is
      // out of frame), matching the Represent pattern. Any amount of
      // vertical scroll counts — we don't want a flicker strip where
      // the header is both scrolled-past and still transparent.
      if (y > 4) {
        root.classList.add('is-scrolled');
      } else {
        root.classList.remove('is-scrolled');
      }

      if (y < threshold) {
        root.classList.remove('header-scroll-hidden');
        upAccum = 0;
        downAccum = 0;
        return;
      }

      if (dy > 0) {
        downAccum += dy;
        upAccum = 0;
        if (downAccum > commitPx) {
          root.classList.add('header-scroll-hidden');
        }
      } else if (dy < 0) {
        upAccum += -dy;
        downAccum = 0;
        if (upAccum > commitPx) {
          root.classList.remove('header-scroll-hidden');
        }
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Safety net: if somehow scroll ends with the header hidden but the
    // user is at the very top of the page, force-show it.
    window.addEventListener('scrollend', function () {
      if ((window.scrollY || 0) < threshold) {
        root.classList.remove('header-scroll-hidden');
      }
    }, { passive: true });

    // Ajax navigation (collection filter / load-more / etc.) —
    // reset state so the header re-shows after the content swap.
    document.addEventListener('theme:loading:end', function () {
      root.classList.remove('header-scroll-hidden');
      lastY = window.scrollY || 0;
    });
  }
})();
